export default __webpack_public_path__ + "static/media/banner-signup.e13aa903.png";